<script>
    export let isLoading = false;
    export let label = "Submit";
</script>

<button type="submit">
    {#if isLoading}
        <span class="spinner" />
    {:else}
        <span>
            {label}
        </span>
    {/if}
</button>
